import { useState } from 'react';
import { apiFetch } from '../../../auth/apiFetch';

const apiBaseUrl = process.env.REACT_APP_XMP_EDITOR_URL || process.env.REACT_APP_API_URL || window.location.origin;

export function useXmpEdit() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const editFiles = async (files) => {
    setLoading(true);
    setError(null);
    setResults([]);
    const formData = new FormData();
    files.forEach((f) => formData.append('files', f));
    try {
      const res = await apiFetch(`${apiBaseUrl}/api/xmp/edit`, {
        method: 'POST',
        body: formData,
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setResults(await res.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return { editFiles, results, loading, error };
}
